/**
 * @param { Object } Enum
 * @param { Array } allowedArray Allowed keys that should be filtered from the enum
 * @returns
 */
export function getTailwindClassesByEnum(Enum, allowedArray = []) {
	const tailWindClasses = Object.keys(Enum)
		.filter(key => allowedArray?.includes(key))
		.reduce((obj, key) => {
			const filteredClasses = obj;
			filteredClasses[key] = Enum[key];

			return filteredClasses;
		}, {});

	return Object.values(tailWindClasses).join(' ');
}

/**
 * @param { Object } Enum
 * @param { String } allowedString Allowed string that should return the right enum value
 * @returns {String}
 */
export function getTailwindClassByEnum(Enum, allowedString) {
	return Enum?.[allowedString] || '';
}
